import * as R from 'ramda';
import { ProductDetailsStore } from './productDetails.types';

export interface SelectIsCombinationMassActionSelectedParams {
  combinationKey: string;
  isPasteDisabled: boolean;
}

export const selectIsProductDetailsOpen = (state: ProductDetailsStore) => {
  const { isOpen, productColorId, kitId } = state.productDetailsModalState;

  return isOpen && (!!productColorId || !!kitId);
};

export const selectHasCopiedGrid = (state: ProductDetailsStore) => state.copiedGrid.grid.length > 0;

export const selectIsMassActionBarOpen = (state: ProductDetailsStore) => !!state.copiedGrid.product;

export const selectIsCombinationMassActionSelected =
  ({ combinationKey, isPasteDisabled }: SelectIsCombinationMassActionSelectedParams) =>
  (state: ProductDetailsStore): boolean => {
    const { isAllItemsSelected, items, unselectedItems } = state.pasteGridMassAction;

    if (isAllItemsSelected) {
      return !isPasteDisabled;
    }

    if (!R.isEmpty(unselectedItems)) {
      return !unselectedItems[combinationKey];
    }

    return !!items[combinationKey];
  };
